import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase, CardContent, ClickAwayListener, Grid, Paper, Popper, Stack, Typography } from '@mui/material';
// project-imports
import ProfileTab from './ProfileTab';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import useAuth from 'hooks/useAuth';
import { ThemeMode } from 'config';

// assets
// import avatar1 from 'assets/images/users/avatar-6.png';
// import Dummy from 'assets/images/users/Dummy.png';
import Dummy1 from 'assets/images/users/Dummy1.png';

// tab panel wrapper
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
      sx={{ p: 1 }}
    >
      {value === index && children}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

// This is Project Icon Component

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const ProfilePage = () => {
  const theme = useTheme();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error(err);
    }
  };

  const name = localStorage.getItem('username');
  const role = localStorage.getItem('role');

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const [value, setValue] = useState(0);
  {
    setValue;
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 0.35, backgroundColor: '#ebe8e8', px: { xs: 0.75, sm: 1.5 }, py: 0.55, borderRadius: 1 }}>
      <Stack onClick={handleToggle} sx={{ cursor: 'pointer' }} direction="row" alignItems="center" spacing={1}>
        {/* Name/role text takes real width and isn't worth it on a phone-sized header — the
            avatar (and the popper it opens) already carries the same info. */}
        <Stack direction="column" alignItems="flex-end" sx={{ lineHeight: 1.2, display: { xs: 'none', sm: 'flex' } }}>
          {/* User Name */}
          <Typography
            variant="subtitle1"
            sx={{
              // fontWeight: 600,
              color: '#000',
              lineHeight: 1.1,
              mt: '4px'
            }}
          >
            {name || 'Unknown User'}
          </Typography>

          {/* Role (styled like badge text) */}
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              textTransform: 'capitalize',
              fontSize: '0.75rem',
            }}
          >
            {role || 'Unknown Role'}
          </Typography>

        </Stack>
        <ButtonBase

          sx={{
            p: 0.25,
            borderRadius: 1,
            '&:hover': { bgcolor: theme.palette.mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.lighter' },
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.secondary.dark}`,
              outlineOffset: 2
            }
          }}
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
        // onClick={handleToggle}
        >
          <Avatar alt="profile user" src={Dummy1} size="sm" />
        </ButtonBase>
      </Stack>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 290,
                minWidth: 240,
                maxWidth: 290,
                [theme.breakpoints.down('md')]: {
                  maxWidth: 250
                },
                borderRadius: 1.5
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} content={false}>
                  <CardContent sx={{ px: 2.5 }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Stack direction="row" spacing={1.25} alignItems="center">
                        <Avatar alt="profile user" src={Dummy1} />
                        <Stack>
                          <Typography variant="subtitle1"> {name || 'Unknow User'}</Typography>
                          <Typography variant="body2" color="secondary">
                            {role || 'Unknow User'}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </CardContent>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}></Box>
                  <TabPanel value={value} index={0} dir={theme.direction}>
                    <ProfileTab handleLogout={handleLogout} handleClose={handleClose} />
                  </TabPanel>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default ProfilePage;
